import React, { useState } from "react";
import "../../Pages/Styles/common-styles.css"
import "./shareButton.css"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFacebook, faInstagram, faLinkedin } from "@fortawesome/free-brands-svg-icons";

const ShareButton = ({ postId, postTitle, context = "", nshare=0 }) => {
  const [showPopup, setShowPopup] = useState(false);
  const className = context === "userProfile" ? "up-text-label" : "text-label";

  const shareOptions = [
    { name: "Facebook", logo: <FontAwesomeIcon icon={faFacebook} />, url: "https://facebook.com" },
    { name: "Instagram", logo: <FontAwesomeIcon icon={faInstagram} />, url: "https://instagram.com" },
    { name: "LinkedIn", logo: <FontAwesomeIcon icon={faLinkedin} />, url: "https://linkedin.com" },
  ];
  

  const handleShareClick = (shareUrl) => {
    window.open(shareUrl, "_blank");
    setShowPopup(false); // Close popup after clicking
  };

  return (
    <div style={{marginTop: 5}}>
      {/* Share span button */}
      <span 
        onClick={() => setShowPopup(!showPopup)}
        className={className}
        style={{fontStyle: 18, fontWeight: "normal", marginLeft: 30}}
      >
        🔗
      </span>

      {/* Popup Container */}
      {showPopup && (
      <div
        style={{
          position: "absolute",
          top: "76%",
          left: "23%",
          transform: "translate(-50%, -50%)",
          height: "60px",
          width: "220px",
          background: "lightgray",
          borderRadius: "12px",
          boxShadow: "0 4px 8px rgba(0,0,0,0.2)",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-around",
          zIndex: 1000,
          padding: "10px",
        }}
      >
        {shareOptions.map((option, index) => (
          <div
            key={index}
            onClick={() => handleShareClick(option.url)}
            style={{
              position: "relative",
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            {/* Logo Icon */}
            <div
              style={{
                fontSize: "22px",
                color: "black",
                background: "darkgray",
                height: "40px",
                width: "40px",
                borderRadius: "50%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                transition: "all 0.3s ease",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.background = "#0077ff"; // subtle blue highlight
                e.currentTarget.style.color = "white";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.background = "darkgray";
                e.currentTarget.style.color = "black";
              }}
            >
              {option.logo}
            </div>

            {/* Tooltip Label */}
            <span
              style={{
                position: "absolute",
                bottom: "-28px",
                left: "50%",
                transform: "translateX(-50%)",
                backgroundColor: "black",
                color: "white",
                padding: "4px 8px",
                borderRadius: "6px",
                fontSize: "12px",
                whiteSpace: "nowrap",
                opacity: 0,
                pointerEvents: "none",
                transition: "opacity 0.2s ease-in-out",
              }}
              className="tooltip-label"
            >
              {option.name}
            </span>
          </div>
        ))}
      </div>
    )}
    </div>
  );
};

export default ShareButton;
